<template>
  <div class="category-navigation">
    <!-- <div class="category-header">
      <h3 class="section-title">产品分类</h3>
      <div class="category-divider"></div>
    </div> -->

    <div class="category-grid custom fade-in" v-fade-in>
        <router-link v-for="category in this.categories" :key="category.id"
          :to="{ path: '/products/category', query: { id: category.id } }" class="category-item">
              <img class="img-fluid"   :src="$globalUploadArr + category.imageUrl"
                :lazy="true" loading="lazy" :alt="category.name">
              <div style="padding: 0 20px;justify-self: flex-start;">
                <h4> {{ category.name }}
                  <i class="el-icon-arrow-right"></i>
                </h4>
                <p class="desc-text" style="text-align: justify;line-height:1.5;min-height:60px;">
                  {{ category.simpleIntroduce }}
                </p>
              </div>
        </router-link>
    
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryNavigation',
  props: {
    categories: {
      type: Array
    }
  },
  data() {
    return {

    }
  },
  computed: {
    firstColumnCategories() {
      return this.categories.slice(0,this.categories.length /2  +  (this.categories.length %2 === 0? 0 :1))
    },
    secondColumnCategories() {
      if(this.categories.length %2 === 0){
        return this.categories.slice(this.categories.length /2)
      }else{
        return this.categories.slice(this.categories.length /2 +1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.category-navigation {
  background: #fff;
  border-radius: 8px;
  padding: 0 0px;
}

// .section-title {
//   font-size: 2.0rem;
//   color: #001F3F;
//   margin-bottom: 1.5rem;
//   padding-left: 0.5rem;
//   border-left: 4px solid #0962d0;
// }

.category-image {
  width: 100%;
  padding: 20px;
  object-fit: contain;
  /* 或者使用contain, none等以适应或保持图片比例 */
}

.category-header {
  margin-bottom: 20px;

  h2 {
    font-size: 18px;
    color: #333;
    margin: 0 0 10px;
    font-weight: 600;
  }

  .category-divider {
    height: 2px;
    background: linear-gradient(90deg, #0962d0 0%, rgba(9, 98, 208, 0.1) 100%);
  }
}

.category-grid {
  display:grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap:20px;
}

.category-column {
}

.category-item {
  display: flex;
  flex-direction: column;
  //align-items: center;
  justify-content: center;
  padding: 20px 0;
  margin: 20px 5px 0;
  align-items: flex-start;
  // background: #2563eb0a;
  border-radius: 6px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s;
  box-shadow: 0px 0px 20px 2px #001F3F11;
  font-size: 15px;

  span:hover {
    color: #0962d0;
  }

  p {
    margin: 10px 0;
    ;
    padding: 0px 0;
  }

  &:hover {
    color: #1A2B3C;
    border-bottom: 4px solid #0072CE;
    transform: translateY(-5px);
    background: rgba(47, 110, 192, 0.060);

    // 
    .el-icon-arrow-right {
      color: #0962d0;
    }
  }

  .el-icon-arrow-right {
    color: #999;
    font-size: 14px;
    transition: color 0.3s;
  }
}

@media (max-width: 768px) {
  .category-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 12px;
  }

  .category-item {
    font-size: 14px;
  }
}
</style>